module.exports = __webpack_public_path__ + "static/media/pecas-1.69fbe07b.png";